import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentWrapper } from 'src/app/wrappers/environment.wrapper';
import { Environment } from 'src/environments/environment.utils';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentAdapter {
  constructor(private wrapper: EnvironmentWrapper) {}

  getEnvironment(): Observable<Environment> {
    const environment = this.wrapper.getEnvironment();
    const environmentObservable = of(environment);

    return environmentObservable;
  }

  isDevEnvironment(): Observable<boolean> {
    const isDevObservable = this.getEnvironment().pipe(map((environment: Environment) => !environment.production));

    return isDevObservable;
  }
}
